import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MasterLayoutComponent } from './master-layout/master-layout.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MasterLayoutComponent,
    SidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    SharedComponentsModule,
   /* BrowserAnimationsModule*/
   /* LanguageModule*/
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutComponentModule {}
